<template>
    <el-drawer
        :title="id ? '编辑待办' : '新建待办'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="600px"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                size="medium"
            >
                <el-card header="待办内容" shadow="never">
                    <el-form-item prop="title" label="待办名称:">
                        <el-input placeholder="请输入待办名称" v-model="formData.title" maxlength="40" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item prop="content" label="操作内容:">
                        <el-input type="textarea" placeholder="请输入操作内容" v-model="formData.content" maxlength="2000" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item prop="relatedObjects" label="关联对象:">
                        <div slot="label">
                            <span>关联对象：</span>
                            <el-button type="primary" size="mini" plain @click="addRelatedObject">新建关联对象</el-button>
                        </div>
                        <el-form-item v-for="(item, index) in formData.relatedObjects" :key="index">
                            <div class="flex items-center">
                                <div style="width: 120px;">
                                    <el-select v-model="formData.relatedObjects[index].objectType" @change="formData.relatedObjects[index].objectId = ''">
                                        <el-option label="演出" :value="1"></el-option>
                                        <el-option label="巡演" :value="2"></el-option>
                                    </el-select>
                                </div>
                                <div class="flex-1">
                                    <el-select v-model="formData.relatedObjects[index].objectId" placeholder="请输入关联对象ID" filterable
                                        remote @focus="relatedObjectsIndex = index" :remote-method="searchRelatedObject" :loading="relatedObjectLoading">
                                        <el-option v-for="item in relatedObjectList[index]" :key="item.id" :label="item.name"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </div>
                                <el-button type="danger" plain @click="removeRelatedObject(index)">删除</el-button>
                            </div>
                        </el-form-item>
                    </el-form-item>
                </el-card>
                <el-card header="任务分配" shadow="never">
                    <el-form-item prop="assigneeIds" label="处理人:">
                        <el-select v-model="formData.assigneeIds" placeholder="请选择处理人" multiple filterable remote :remote-method="searchUser" @focus="searchUser('')" :loading="userLoading">
                            <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-card>
                <el-card header="任务设置" shadow="never">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12">
                            <el-form-item prop="categoryId" label="任务分类:">
                                <el-select v-model="formData.categoryId" placeholder="请选择任务分类" filterable clearable>
                                    <el-option v-for="item in categoryList" :key="item.key" :label="item.value" :value="item.key"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item prop="priority" label="优先级:">
                                <el-select v-model="formData.priority" placeholder="请选择优先级">
                                    <el-option label="高" :value="1"></el-option>
                                    <el-option label="中" :value="2"></el-option>
                                    <el-option label="低" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12">
                            <el-form-item prop="completeType" label="完成方式:">
                                <el-select v-model="formData.completeType" placeholder="请选择完成方式">
                                    <el-option label="任一完成（任一人完成即结束任务并停止后续提醒）" :value="1"></el-option>
                                    <el-option label="全部完成（所有处理人完成才结束任务）" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12">
                            <el-form-item prop="deadline" label="计划执行时间:">
                                <el-date-picker v-model="formData.deadline" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item prop="remindConfig.firstRemindTime" label="第一轮提醒时间(分钟):">
                                <el-input-number v-model="formData.remindConfig.firstRemindTime"
                                    placeholder="请输入第一轮提醒时间" :precision="0" :controls="false" style="width: 100%;" ></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12">
                            <el-form-item prop="remindConfig.secondRemindTime" label="第二轮提醒时间(分钟):">
                                <el-input-number v-model="formData.remindConfig.secondRemindTime"
                                    placeholder="请输入第二轮提醒时间" :precision="0" :controls="false"
                                    style="width: 100%;" :min="1"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item prop="remindConfig.feishuRemind" label="同步发送飞书提醒:">
                                <el-radio-group v-model="formData.remindConfig.feishuRemind">
                                    <el-radio :label="1" border>开启</el-radio>
                                    <el-radio :label="2" border>关闭</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item prop="remark" label="创建备注:">
                        <el-input type="textarea" placeholder="请输入创建备注" v-model="formData.remark" maxlength="500"
                            show-word-limit></el-input>
                    </el-form-item>
                </el-card>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >保存</el-button
            >
        </div>
    </el-drawer>
</template>
<script>
const defaultFormData = {
    assigneeIds: [], //处理人ID列表
    categoryId: '', //分类ID
    completeType: 1, //完成方式：1-任一完成（默认，任一人完成即结束任务并停止后续提醒），2-全部完成
    content: '', //待办详细内容
    deadline: '', //计划执行时间
    priority: 2, //优先级：1-高，2-中，3-低
    remark: '', //备注
    title: '', //待办标题
    relatedObjects: [{
        objectType: 1, //关联对象类型：1-演出，2-巡演
        objectId: '', //关联对象ID
    }], //关联对象列表
    remindConfig: {
        feishuRemind: 1, //飞书提醒开关：1-开启，2-关闭
        firstRemindTime: 10, //第一轮提醒时间
        secondRemindTime: 5, //第二轮提醒时间
    }, //提醒配置
}
// 需求7139979129：深拷贝默认表单，避免 relatedObjects/remindConfig 引用共享被污染
const getDefaultFormData = () => JSON.parse(JSON.stringify(defaultFormData));
export default {
    
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            dataLoading: false,
            id:'',
            formData: getDefaultFormData(),
            
            rules:{               
                title: [
                    { required: true, message: '请输入待办名称' },
                    //待办名称长度限制 2-40 字（PRD 定义）
                    { min: 2, max: 40, message: '待办名称长度需在 2 到 40 个字之间' },
                ],
                content: [
                    { required: true, message: '请输入操作内容' },
                ],
                assigneeIds: [
                    { required: true, message: '请选择处理人' },
                ],
                deadline: [
                    { required: true, message: '请选择计划执行时间' },
                ],
            },

            // 用户加载状态
            userLoading: false,
            // 用户列表
            userList: [],
            // 关联对象加载状态
            relatedObjectLoading: false,
            // 关联对象列表
            relatedObjectList: [],
            // 关联对象索引
            relatedObjectsIndex: 0,
            // 分类列表
            categoryList: [],
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo || {};
        }
    },
    mounted(){
        this.getCategoryList();
    },
    methods:{
        close(){
            this.formData = getDefaultFormData();
            this.$refs.formData.clearValidate();
            this.drawerShow = false;
        },
        show(id){
            this.id = id || '';
            if( this.id ){
                this.getData();
            }else{
                // 初始化处理人ID为当前用户ID
                this.formData.assigneeIds = this.userInfo.id ? [this.userInfo.id] : [];
                this.userList = [{
                    id: this.userInfo.id || '',
                    name: this.userInfo.name || '',
                }];
            }
            this.drawerShow = true;
        },
        // 获取分类列表
        async getCategoryList(){
            const res = await this.$request({
                url: "/pendingtask/categorySelect",
                method: "post",
            });
            const { state, result } = res.data;
            if (state == 1) {
                this.categoryList = result || [];
            }
        },

        getData(){
            this.dataLoading = true;
            this.$request({
                url: "/pendingtask/detail",
                data: { pendingTaskId: this.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.formData = {
                            ...getDefaultFormData(),
                            categoryId: result?.taskInfo?.categoryId || defaultFormData.categoryId,
                            completeType: result?.taskInfo?.completeType || defaultFormData.completeType,
                            content: result?.taskInfo?.content || defaultFormData.content,
                            deadline: result?.taskInfo?.deadline || defaultFormData.deadline,
                            priority: result?.taskInfo?.priority || defaultFormData.priority,
                            remark: result?.taskInfo?.remark || defaultFormData.remark,
                            title: result?.taskInfo?.title || defaultFormData.title,
                            relatedObjects: result?.taskInfo?.relatedObjects || getDefaultFormData().relatedObjects,
                            remindConfig: result?.remindConfig ? {
                                feishuRemind: result?.remindConfig?.firstRemind?.feishuRemind || defaultFormData.remindConfig.feishuRemind,
                                firstRemindTime: result?.remindConfig?.firstRemind?.time || defaultFormData.remindConfig.firstRemindTime,
                                secondRemindTime: result?.remindConfig?.secondRemind?.time || defaultFormData.remindConfig.secondRemindTime,
                            } : getDefaultFormData().remindConfig,
                            pendingTaskId: this.id,
                        };
                        if( result?.taskInfo?.assignees ){
                            // 初始化处理人ID列表
                            this.formData.assigneeIds = result?.taskInfo?.assignees.map(v => v.assigneeId) || [];
                            this.userList = result?.taskInfo?.assignees.map(v => ({
                                id: v.assigneeId || '',
                                name: v.assigneeName || '',
                            }));
                        }else{
                            // 初始化处理人ID为当前用户ID
                            this.formData.assigneeIds = this.userInfo.id ? [this.userInfo.id] : [];
                            this.userList = [{
                                id: this.userInfo.id || '',
                                name: this.userInfo.name || '',
                            }];
                        }
                        if( result?.taskInfo?.relatedObjects ){
                            // 初始化关联对象列表
                            result?.taskInfo?.relatedObjects.map(v => (
                                this.relatedObjectList.push([{
                                    id: v.objectId || '',
                                    name: v.objectName || '',
                                }])
                            ));
                        }
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        // 读取最近选择过的处理人（需求7139979129）
        getRecentAssignees() {
            try {
                return JSON.parse(localStorage.getItem('recentAssigneeOptions') || '[]');
            } catch (err) {
                return [];
            }
        },
        // 记录最近选择过的处理人（最新在前，最多保留20个）
        saveRecentAssignees(users) {
            if (!users || !users.length) return;
            const recent = this.getRecentAssignees().filter(v => !users.some(u => u.id === v.id));
            localStorage.setItem('recentAssigneeOptions', JSON.stringify([...users, ...recent].slice(0, 20)));
        },
        // 搜索用户
        async searchUser(query) {
            this.userLoading = true;
            try {
                const res = await this.$request({
                    url: '/adminUser/list',
                    method: 'post',
                    params: {
                        keyword: query,
                    },
                });
                const { state, result } = res.data;
                // 请求成功时更新用户列表
                if (state == 1 && result) {
                    if (!query) {
                        this.userList = this.userList.concat([...result]);
                    } else {
                        this.userList = result;
                    }
                    // 去重
                    this.userList = this.userList.filter((item, index, self) =>
                        index === self.findIndex(t => t.id === item.id)
                    );
                    // 需求7139979129：最近选择过的处理人排在前面
                    const recentIds = this.getRecentAssignees().map(v => v.id);
                    if (recentIds.length) {
                        this.userList.sort((a, b) => {
                            const ai = recentIds.indexOf(a.id);
                            const bi = recentIds.indexOf(b.id);
                            return (ai === -1 ? recentIds.length : ai) - (bi === -1 ? recentIds.length : bi);
                        });
                    }
                }
            } catch (err) {
                this.$message.error('搜索用户失败');
            } finally {
                this.userLoading = false;
            }
        },
        // 添加关联对象
        addRelatedObject(){
            this.formData.relatedObjects.push({
                objectType: 1, //关联对象类型：1-演出，2-巡演
                objectId: '', //关联对象ID
            })
        },
        // 删除关联对象
        removeRelatedObject(index){
            this.formData.relatedObjects.splice(index, 1);
        },
        // 搜索关联对象
        async searchRelatedObject(query) {
            this.relatedObjectLoading = true;
            try {
                const res = await this.$request({
                    url: '/pendingtask/getObjectName',
                    method: 'post',
                    params: {
                        objectId: query,
                        objectType: this.formData.relatedObjects[this.relatedObjectsIndex].objectType,
                    },
                });
                const { state, result } = res.data;
                // 请求成功时更新关联对象列表
                if (state == 1 && result) {
                    this.relatedObjectList[this.relatedObjectsIndex] = [{
                        id: query,
                        name: result,
                    }];
                }
            } catch (err) {
                this.$message.error('搜索关联对象失败');
            } finally {
                this.relatedObjectLoading = false;
            }
        },
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    const _url = this.id ? '/pendingtask/update' : '/pendingtask/create'
                    // BUG-01修复：deadline 兜底转字符串——Date 对象经 JSON.stringify 变 ISO 格式（含T/Z），
                    // 后端 Jackson 全局 date-format 只认 yyyy-MM-dd HH:mm:ss，解析失败直接 500
                    const submitData = { ...this.formData };
                    if (submitData.deadline instanceof Date) {
                        const d = submitData.deadline;
                        const pad = n => String(n).padStart(2, '0');
                        submitData.deadline = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
                    }
                    this.$request({
                        url: _url,
                        data: {
                            ...submitData,
                            // 需求7139979129：过滤掉关联对象ID为空的行，不再强制必填
                            relatedObjects: this.formData.relatedObjects.filter(item => item.objectId),
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                // 需求7139979129：记录最近选择的处理人
                                this.saveRecentAssignees(this.formData.assigneeIds.map(id => {
                                    const user = this.userList.find(u => u.id == id);
                                    return user ? { id: user.id, name: user.name } : null;
                                }).filter(Boolean));
                                this.$router.replace({
                                    path: `/workbench/work`,
                                    query: {
                                        ...this.$route.query,
                                        v: new Date().getTime(),
                                    },
                                });
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.flex {
    display: flex;
    gap: 10px;
    &.items-center {
        align-items: center;
    }
    &.justify-between {
        justify-content: space-between;
    }
    .flex-1 {
        flex: 1;
    }
}
</style>